import React from "react";
import { Box, Container, Typography, makeStyles } from "@material-ui/core";
import { Page } from "@packages/ui";
import getCountryFromURL from "src/utils/getCountryFromUrl";
import getBrandFromUrl from "src/utils/getBrandFromUrl";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: 50,
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  image: {
    marginTop: 50,
    display: "inline-block",
    maxWidth: "100%",
    width: 560,
  },
}));

const getPhoneNumber = () => {
  const country = getCountryFromURL();
  const brand = getBrandFromUrl();
  return country == "AU" && brand == "Thrifty"
    ? "13 61 39"
    : brand == "Dollar" && country == "AU"
    ? "1800 501 934"
    : country == "AU"
    ? "13 30 39"
    : "0800 654 321";
};

const Expire = () => {
  const classes = useStyles();

  return (
    <Page className={classes.root} title="404">
      <Box display="flex" flexDirection="column" height="100%" justifyContent="center">
        <Container maxWidth="md">
          <Typography align="center" color="textPrimary" variant="h1">
            Your session is expired
          </Typography>
          <Typography align="center" color="textPrimary" variant="subtitle2">
            If you need more help please contact {getPhoneNumber()}
          </Typography>
          <Box textAlign="center">
            <img
              alt="Under development"
              className={classes.image}
              src="/static/images/not_found.png"
            />
          </Box>
        </Container>
      </Box>
    </Page>
  );
};

export default Expire;
